type Translation = Record<
  string,
  {
    bookingLink: string;
    header: string;
    subheading: string;
    linkText: string;
    steps: { title: string; content: string }[];
    stepsTitle: string;
    stepsSubtitle: string;
    stepsCTA: string;
    decorators?: {
      name: string;
      title: string;
      desktopImage: { id: string; url: string };
      mobileImage: { id: string; url: string };
    }[];
    decoratorsTitle?: string;
    decoratorsCTA?: string;
    categories: {
      header: string;
      desktopImage: { id: string; url: string };
      mobileImage: { id: string; url: string };
    }[];
    categoriesTitle: string;
    questions: { title: string; content: string }[];
    questionsTitle: string;
    questionsSubtitle: string;
    questionsLink: string;
    questionsCTA: string;
  }
>;

export const translations: Translation = {
  "sv-se": {
    bookingLink:
      "https://outlook.office365.com/book/Inredningstjanst1@nordiskagalleriet.com/",
    header: "Välkommen till Nordiska Galleriets inredningsateljé",
    subheading:
      "Få kostnadsfri rådgivning av våra arkitekter och inredare. Tjänsten är tillgänglig för alla typer av projekt, oavsett om du behöver hjälp med ett möbelval eller inredning för ett helt hem.",
    linkText: "Boka tid",
    steps: [
      {
        title: "Boka tid",
        content:
          "Du väljer en tid. Boka ett förutsättningslöst digitalt eller fysiskt möte med våra inredare eller arkitekter.",
      },
      {
        title: "Matcha med inredare",
        content:
          "Vi matchar dig med en inredare baserat på dina behov och plats.",
      },
      {
        title: "Konsultation",
        content: "Ett första möte om önskemål, förutsättningar och omfattning.",
      },
      {
        title: "Konceptutveckling",
        content: "Vårt team tar fram ett kostnadsfritt koncept.",
      },
      {
        title: "Inredningsförslag",
        content: "Vi presenterar ett inredningsförslag för dig.",
      },
      {
        title: "Projektledning och leverans",
        content: "Din inredare hör sen av sig för att stämma av hur du trivs.",
      },
    ],
    stepsTitle: "Så fungerar det",
    stepsSubtitle: "Boka ett kostnadsfritt digitalt eller fysiskt möte",
    stepsCTA: "Boka tid",
    decorators: [
      {
        name: "Lisa Viberg",
        title: "Inredningsdesigner",
        desktopImage: {
          id: "49f2a5b3-b0c9-40f7-af9a-5b275915bca8",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7EAQscEd9oZT5aNeX0j9kq/a34f61b10e41b6da52e7e92204e8d87c/Inredningstjanst_Lisa-Viberg_desktop.jpg",
        },
        mobileImage: {
          id: "3fb8dfc0-db90-4424-b870-30c3ac7a2203",
          url: "https://images.ctfassets.net/itxkjaj41rzb/5uP0i9mGOMGREAnnCS95Hx/2dd53dc521ce532bc4cc2f93ea833722/Inredningstjanst_Lisa-Viberg_mobil.jpg",
        },
      },
      {
        name: "Katia Santos",
        title: "Inredningsdesigner",
        desktopImage: {
          id: "db4f18db-5e24-4068-a0a0-b62d242313da",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7q6Er2PJTHU3ZQO83Rzy7s/b02dfe682ba5a25ae870d65bc5012d94/NEW_Katia_santos_desktop.jpg",
        },
        mobileImage: {
          id: "595898a0-bcd7-4e23-96fa-21d88234e3a3",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2Ec343CSl6q3c0GwEgKcOs/34d1926580cea41a47995aa91f3641c2/NEW_Katia_santos_mobil.jpg",
        },
      },
    ],
    decoratorsTitle: "Möt våra inredare och arkitekter",
    decoratorsCTA: "Boka tid med någon av våra inredare",
    categories: [
      {
        header: "Inredningskoncept",
        desktopImage: {
          id: "73d5541d-49f1-46d3-a48e-17e7226db682",
          url: "https://images.ctfassets.net/itxkjaj41rzb/4DIIMGhR9R8Q4mPqW8cL3y/0e6a5d8a24d5f3929ad6777f3faf8881/Inredningstjanst_Inredningskoncept_desktop.jpg",
        },
        mobileImage: {
          id: "44f6dd9b-ba5e-4230-a2d5-6583873dcc72",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2thYNt70WuSTf6Gd1TZJ0y/5e5efe01f17b09f8938a747ac5fdef9a/Inredningstjanst_Inredningskoncept_mobil.jpg",
        },
      },
      {
        header: "Möbelval",
        desktopImage: {
          id: "f0f8a52a-5a73-4c90-bf16-3197188dd845",
          url: "https://images.ctfassets.net/itxkjaj41rzb/fOp0yl6VFBzMdDooCD6C8/4c896ecf7f26c6d4e688c8475aaf0c89/Inredningstjanst_Mo_belval_desktop.jpg",
        },
        mobileImage: {
          id: "b9f72fcc-8003-4367-aa2f-3ddbe49a1a13",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7tvSk9QOOsTBNvDbFjJmzG/27349e72d7611e0d0135246aa61f4f9c/Inredningstjanst_Mobelval_mobil.jpg",
        },
      },
      {
        header: "Belysning",
        desktopImage: {
          id: "dd84d366-8d02-4fad-9352-012870ddd647",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2cnJkgnmp0S0D1D57su7GT/e39c84a00f0cd3627e0f7a1e5e3c7cf1/Inredningstjanst_Belysning_desktop.jpg",
        },
        mobileImage: {
          id: "7b673407-9a62-4d5c-8219-81691920c568",
          url: "https://images.ctfassets.net/itxkjaj41rzb/5bm9F3uskhPE6JYtgqBl1e/979da9daaa5d15754d947698b86a1715/Inredningstjanst_Belysning_mobil.jpg",
        },
      },
      {
        header: "Mattor",
        desktopImage: {
          id: "3668d6f0-eedd-42a7-bfc2-8415145540f3",
          url: "https://images.ctfassets.net/itxkjaj41rzb/6lyApF8EY3iBUFYo0p5HA2/93015100faef249c09d28dc243847ff5/Inredningstjanst_Mattor_desktop.jpg",
        },
        mobileImage: {
          id: "d4969b76-e018-466b-9832-436add876176",
          url: "https://images.ctfassets.net/itxkjaj41rzb/1yHM9UwF9kRuDe7vOl2HUu/be24cff4427aac59583891b99480f4e6/Inredningstjanst_Mattor_mobil.jpg",
        },
      },
      {
        header: "Kök och garderobslösningar",
        desktopImage: {
          id: "9efc80e7-ec6d-434b-a9bc-95fe67db1cd2",
          url: "https://images.ctfassets.net/itxkjaj41rzb/1C1AwvUhuA1AF6hpL2wPem/55e6a227818862ab1b3fa4f329a37869/inredningstjanst_kok_o_garderobslo_sningar_desktop.jpg",
        },
        mobileImage: {
          id: "7d6b813f-4f56-4bcf-b8ad-0cc8320c3fd0",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7N295NIn2fDlRS4eRXn4RF/043bd4a79f8deffee264d64190687010/inredningstjanst_kok_o_garderobslosningar_mobil.jpg",
        },
      },
      {
        header: "Textilier och materialval",
        desktopImage: {
          id: "dd7380e5-cf33-46ba-93bb-73e6ee433831",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7KYFWRJ6HPCQJVGYgdkYiW/09988e4361e791a168af4ffdd6a0c9ab/inredningstjanst_textilier_o_materialval_deskop.jpg",
        },
        mobileImage: {
          id: "0ff56fcb-49cb-4f01-a2dd-46e95e0f1935",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2kqOOy3Ssw1cPDI5Ck2GX1/cbf918c2fd51804191f490bc6009da26/inredningstjanst_textilier_o_material_mobiljpg.jpg",
        },
      },
      {
        header: "Sängar och sovrum",
        desktopImage: {
          id: "df78503d-3296-4282-ba8a-f81d852f327a",
          url: "https://images.ctfassets.net/itxkjaj41rzb/77e7yxlRrQbbcuOyk4w8LK/e37ecdb57a4c53ec7f43e4108aee8a68/Inredningstjanst_sang_o_sovrum_desktop.jpg",
        },
        mobileImage: {
          id: "d51e471d-d9b7-4da9-a690-6371dc0181ed",
          url: "https://images.ctfassets.net/itxkjaj41rzb/6GmDXLA5Xt2aeizJR0fFoG/edf3e6893e3f71ef1eaae193a6b3a93c/Inredningstjanst_Sang-sovrum_mobil.jpg",
        },
      },
      {
        header: "Specialanpassad inredning",
        desktopImage: {
          id: "80492dc6-1713-42ea-b6e6-1ed3ae1480b0",
          url: "https://images.ctfassets.net/itxkjaj41rzb/32s2nD7fAiupm2DXN0uSZW/8cb91a0ff49238184609bf86aba4238d/Inredningstjanst_Specialanpassad_inredning_desktop.jpg",
        },
        mobileImage: {
          id: "c086494c-db28-4f7f-bbf5-b9a0dbbb6cbe",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7qzpWQGyjFMCc8IXmq5N42/722e95836f243db7a19ed2a7c79fd69b/Inredningstjanst_Specialanpassad-inredning_mobil.jpg",
        },
      },
    ],
    categoriesTitle: "Vad kan vi hjälpa till med",
    questions: [
      {
        title: "Vad ingår i tjänsten?",
        content:
          "I vår inredningstjänst så hjälper vi dig med din inredning från start till mål. Vi analyserar ditt och hemmets behov och tar därifrån fram ett inredningsförslag med produkter från vårt sortiment. Inredningsförslaget kan presenteras i form av en moodboard, produktförslag och en 3D-ritning beroende på förslagets omfattning.",
      },
      {
        title: "Hur mycket kostar tjänsten?",
        content:
          "Vår inredningstjänst är helt kostnadsfri. Vi ser vår tjänst som ett sätt att hjälpa dig att hitta rätt bland vårt exklusiva sortiment, och vi hoppas att våra rekommendationer leder till att du väljer att handla hos oss. Vår inredningstjänst är försäljningsbaserad, vilket innebär att vi strävar efter att skapa en lösning som matchar dina behov med de produkter vi erbjuder.",
      },
      {
        title: "Kan jag boka en tid i någon av era butiker?",
        content:
          "I vår bokningstjänst kan du enkelt välja mellan ett digitalt eller fysiskt möte med en av våra inredare på någon av våra butiker: Nybrogatan 11 i Stockholm, Flöjelbergsgatan 20A i Göteborg eller Engelbrektsgatan 9 i Malmö.",
      },
      {
        title: "Hur köper jag produkterna i mitt inredningsförslag?",
        content:
          "När du känner dig nöjd med ditt inredningsförslag hjälper inredaren dig att lägga en beställning. Inredaren kommer sedan vara din primära kontakt ända tills att du har mottagit dina nya produkter. Inredaren kommer dessutom att vara din kontaktperson vid eventuella framtida ärenden.",
      },
      {
        title:
          "Vad kostar det att inreda ett helt hem med möbler och inredning från er?",
        content:
          "Nordiska Galleriet har en stor varumärkesportfölj och erbjuder möbler, belysning och inredningsdetaljer inom flera olika prissegment. Kostnaden att inreda ett hem kan därför skilja sig väldigt mycket. Genom en nära dialog med inredaren kommer ni kunna ta fram ett inredningsförslag baserat på din budget.",
      },
      {
        title: "Hur mycket kontakt får jag med inredaren?",
        content:
          "För att lyckas med inredningen av ditt hem tror vi på en nära kontakt mellan inredare och kund. Genom denna kontakt kommer vi kunna få en god förståelse för vad just du är ute efter. Inredaren föreslår ett upplägg som är baserat på vad du behöver hjälp med och din budget, så att vi tillsammans kan säkerställa att vi når bästa möjliga resultat. Vi erbjuder kontakt via såväl fysiska möten i butik som per telefon, mejl eller videomöten. Det som passar bäst för dig, passar bäst för oss",
      },
    ],
    questionsTitle: "Vanliga frågor",
    questionsSubtitle: "Hittar du inte svaret på frågan du söker?",
    questionsLink: "Kontakta oss",
    questionsCTA: "Boka tid",
  },
  "nb-no": {
    bookingLink:
      "https://bookings.cloud.microsoft/book/NOGANOinredningsateljKopiera@no-ga.com",
    header: "Velkommen til Nordiska Galleriets innredningsatelier",
    subheading:
      "Få kostnadsfri rådgivning av våre interiørarkitekter og -designere. Tjenesten er tilgjengelig for alle typer interiørprosjekter, enten du trenger hjelp med et møbelvalg eller innredningshjelp for hele hjemmet ditt.",
    linkText: "Bestill time",
    steps: [
      {
        title: "Bestill time",
        content:
          "Du velger et tidspunkt. Bestill et uforpliktende digitalt eller fysisk møte med våre interiørdesignere eller arkitekter.",
      },
      {
        title: "Match med interiørdesigner",
        content:
          "Vi matcher deg med en interiørdesigner basert på dine behov og sted.",
      },
      {
        title: "Konsultasjon",
        content:
          "Et første møte om dine ønsker, mål, forutsetninger og prosjektets omfang.",
      },
      {
        title: "Konseptutvikling",
        content: "Vårt team utarbeider et konsept for deg helt kostnadsfritt.",
      },
      {
        title: "Interiørforslag",
        content: "Vi presenterer et interiørforslag for deg.",
      },
      {
        title: "Prosjektledelse og levering",
        content:
          "Din interiørdesigner tar kontakt for å følge opp hvordan prosjektet har gått.",
      },
    ],
    stepsTitle: "Slik fungerer det",
    stepsSubtitle: "Bestill et kostnadsfritt digitalt eller fysisk møte",
    stepsCTA: "Bestill time",
    categories: [
      {
        header: "Interiørkonsept",
        desktopImage: {
          id: "73d5541d-49f1-46d3-a48e-17e7226db682",
          url: "https://images.ctfassets.net/itxkjaj41rzb/4DIIMGhR9R8Q4mPqW8cL3y/0e6a5d8a24d5f3929ad6777f3faf8881/Inredningstjanst_Inredningskoncept_desktop.jpg",
        },
        mobileImage: {
          id: "44f6dd9b-ba5e-4230-a2d5-6583873dcc72",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2thYNt70WuSTf6Gd1TZJ0y/5e5efe01f17b09f8938a747ac5fdef9a/Inredningstjanst_Inredningskoncept_mobil.jpg",
        },
      },
      {
        header: "Møbelvalg",
        desktopImage: {
          id: "f0f8a52a-5a73-4c90-bf16-3197188dd845",
          url: "https://images.ctfassets.net/itxkjaj41rzb/fOp0yl6VFBzMdDooCD6C8/4c896ecf7f26c6d4e688c8475aaf0c89/Inredningstjanst_Mo_belval_desktop.jpg",
        },
        mobileImage: {
          id: "b9f72fcc-8003-4367-aa2f-3ddbe49a1a13",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7tvSk9QOOsTBNvDbFjJmzG/27349e72d7611e0d0135246aa61f4f9c/Inredningstjanst_Mobelval_mobil.jpg",
        },
      },
      {
        header: "Belysning",
        desktopImage: {
          id: "dd84d366-8d02-4fad-9352-012870ddd647",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2cnJkgnmp0S0D1D57su7GT/e39c84a00f0cd3627e0f7a1e5e3c7cf1/Inredningstjanst_Belysning_desktop.jpg",
        },
        mobileImage: {
          id: "7b673407-9a62-4d5c-8219-81691920c568",
          url: "https://images.ctfassets.net/itxkjaj41rzb/5bm9F3uskhPE6JYtgqBl1e/979da9daaa5d15754d947698b86a1715/Inredningstjanst_Belysning_mobil.jpg",
        },
      },
      {
        header: "Tepper",
        desktopImage: {
          id: "3668d6f0-eedd-42a7-bfc2-8415145540f3",
          url: "https://images.ctfassets.net/itxkjaj41rzb/6lyApF8EY3iBUFYo0p5HA2/93015100faef249c09d28dc243847ff5/Inredningstjanst_Mattor_desktop.jpg",
        },
        mobileImage: {
          id: "d4969b76-e018-466b-9832-436add876176",
          url: "https://images.ctfassets.net/itxkjaj41rzb/1yHM9UwF9kRuDe7vOl2HUu/be24cff4427aac59583891b99480f4e6/Inredningstjanst_Mattor_mobil.jpg",
        },
      },
      {
        header: "Kjøkken- og garderobeløsninger",
        desktopImage: {
          id: "9efc80e7-ec6d-434b-a9bc-95fe67db1cd2",
          url: "https://images.ctfassets.net/itxkjaj41rzb/1C1AwvUhuA1AF6hpL2wPem/55e6a227818862ab1b3fa4f329a37869/inredningstjanst_kok_o_garderobslo_sningar_desktop.jpg",
        },
        mobileImage: {
          id: "7d6b813f-4f56-4bcf-b8ad-0cc8320c3fd0",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7N295NIn2fDlRS4eRXn4RF/043bd4a79f8deffee264d64190687010/inredningstjanst_kok_o_garderobslosningar_mobil.jpg",
        },
      },
      {
        header: "Tekstiler og materialvalg",
        desktopImage: {
          id: "dd7380e5-cf33-46ba-93bb-73e6ee433831",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7KYFWRJ6HPCQJVGYgdkYiW/09988e4361e791a168af4ffdd6a0c9ab/inredningstjanst_textilier_o_materialval_deskop.jpg",
        },
        mobileImage: {
          id: "0ff56fcb-49cb-4f01-a2dd-46e95e0f1935",
          url: "https://images.ctfassets.net/itxkjaj41rzb/2kqOOy3Ssw1cPDI5Ck2GX1/cbf918c2fd51804191f490bc6009da26/inredningstjanst_textilier_o_material_mobiljpg.jpg",
        },
      },
      {
        header: "Senger og soverom",
        desktopImage: {
          id: "df78503d-3296-4282-ba8a-f81d852f327a",
          url: "https://images.ctfassets.net/itxkjaj41rzb/77e7yxlRrQbbcuOyk4w8LK/e37ecdb57a4c53ec7f43e4108aee8a68/Inredningstjanst_sang_o_sovrum_desktop.jpg",
        },
        mobileImage: {
          id: "d51e471d-d9b7-4da9-a690-6371dc0181ed",
          url: "https://images.ctfassets.net/itxkjaj41rzb/6GmDXLA5Xt2aeizJR0fFoG/edf3e6893e3f71ef1eaae193a6b3a93c/Inredningstjanst_Sang-sovrum_mobil.jpg",
        },
      },
      {
        header: "Spesialtilpasset interiør",
        desktopImage: {
          id: "80492dc6-1713-42ea-b6e6-1ed3ae1480b0",
          url: "https://images.ctfassets.net/itxkjaj41rzb/32s2nD7fAiupm2DXN0uSZW/8cb91a0ff49238184609bf86aba4238d/Inredningstjanst_Specialanpassad_inredning_desktop.jpg",
        },
        mobileImage: {
          id: "c086494c-db28-4f7f-bbf5-b9a0dbbb6cbe",
          url: "https://images.ctfassets.net/itxkjaj41rzb/7qzpWQGyjFMCc8IXmq5N42/722e95836f243db7a19ed2a7c79fd69b/Inredningstjanst_Specialanpassad-inredning_mobil.jpg",
        },
      },
    ],
    categoriesTitle: "Hva kan vi hjelpe med",
    questions: [
      {
        title: "Hva inngår i tjenesten?",
        content:
          "I vår interiørtjeneste hjelper vi deg med innredning fra start til slutt. Vi analyserer dine og hjemmets behov, og utarbeider deretter et interiørforslag og konsept med produkter fra vårt sortiment. Interiørforslaget kan presenteres i form av et moodboard, produktforslag og en 3D-tegning, avhengig av forslagets omfang.",
      },
      {
        title: "Hvor mye koster tjenesten?",
        content:
          "Vår interiørtjeneste er helt kostnadsfri. Tjenesten skal hjelpe deg med å finne riktig interiør- og møbelvalg blant vårt eksklusive sortiment, og vi håper at våre anbefalinger fører til at du velger å handle hos akkurat oss. Vår interiørtjeneste er kun basert på vårt produktsortiment, og vi streber etter å skape en løsning som matcher dine behov med produktene vi tilbyr hos oss i Nordiska Galleriet.",
      },
      {
        title: "Kan jeg bestille time i en av butikkene deres?",
        content:
          "I bookingtjenesten vår kan du enkelt velge mellom et digitalt eller fysisk møte med en av våre interiørdesignere i butikken vår på Skøyen i Oslo, Karenslyst Allé 7.",
      },
      {
        title: "Hvordan kjøper jeg produktene i interiørforslaget mitt?",
        content:
          "Når du er fornøyd med interiørforslaget ditt, hjelper interiørdesigneren deg med å legge inn en bestilling. Interiørdesigneren vil deretter være din primærkontakt helt til du har mottatt de nye produktene dine. Interiørdesigneren vil dessuten være kontaktpersonen din ved eventuelle fremtidige henvendelser.",
      },
      {
        title:
          "Hva koster det å innrede et helt hjem med møbler og interiør fra dere?",
        content:
          "Nordiska Galleriet har en stor merkevareportefølje og tilbyr møbler, belysning og interiørdetaljer i flere ulike prissegmenter. Kostnaden for å innrede et hjem kan derfor variere mye. Gjennom tett dialog med interiørdesigneren din vil dere kunne utarbeide et interiørforslag basert på budsjettet ditt.",
      },
      {
        title: "Hvor mye kontakt får jeg med interiørdesigneren?",
        content:
          "For å lykkes med interiøret i hjemmet ditt tror vi på tett kontakt mellom interiørdesigner og kunde. Gjennom denne kontakten vil vi få en god forståelse av hva akkurat du er ute etter. Interiørdesigneren foreslår en plan basert på hva du trenger hjelp med og budsjettet ditt, slik at vi sammen kan sikre at vi oppnår best mulig resultat. Vi tilbyr kontakt både via fysiske møter i butikk og per telefon, e-post eller videomøter. Det som passer best for deg, passer best for oss.",
      },
    ],
    questionsTitle: "Vanlige spørsmål",
    questionsSubtitle: "Finner du ikke svaret på spørsmålet du leter etter?",
    questionsLink: "Kontakt oss",
    questionsCTA: "Bestill time",
  },
};
